import { render, staticRenderFns } from "./DocumentsEdit.vue?vue&type=template&id=13795d54&"
import script from "./DocumentsEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports